import request from './axios';

// article
export const articleSave = (data) => request.postZg('/zg_article/article/save',data,{'X-No-Token': true});

export const findArticle = (data) => request.postZg('/zg_article/article/find',data,{'X-No-Token': true,'contentType' : 'x-www-form-urlencoded'})

export const findBlogPagesNum = (data) => request.postZg('/zg_article/article/findBlogPagesNum',data,{'X-No-Token': true})

export const findBlogPages = (data) => request.postZg('/zg_article/article/findBlogPages',data,{'X-No-Token': true,'contentType' : 'x-www-form-urlencoded'})

export const findRecommendedBlog = (data) => request.postZg('/zg_article/article/findRecommendedBlog',data,{'X-No-Token': true,'contentType' : 'x-www-form-urlencoded'})

export const articleAddReadingQuantity = (data) => request.postZg('/zg_article/article/addReadingQuantity',data,{'X-No-Token': true,'contentType' : 'x-www-form-urlencoded'})

// other

export const findHomeVerse = (data) => request.postZg('/zg_article/other/findHomeVerse',data,{'X-No-Token': true})

// sysNotice

export const findSysNotice = (data) => request.postZg('/zg_article/sysNotice/findSysNotice',data,{'X-No-Token': true})

export const addReadingQuantity = (data) => request.postZg('/zg_article/sysNotice/addReadingQuantity',data,{'X-No-Token': true,'contentType' : 'x-www-form-urlencoded'})

// sysHomeImgs

export const findHomeImgs = (data) => request.postZg('/zg_article/sysHomeImgs/findHomeImgs',data,{'X-No-Token': true})

export const uploadImgs = (data) => request.postZg('/zg_article/sysHomeImgs/uploadImgs',data,{'X-No-Token': true,'contentType' : 'form-data'})

export const uploadImg = (data) => request.postZg('/zg_article/sysHomeImgs/uploadImg',data,{'X-No-Token': true,'contentType' : 'form-data'})

// sysTags

export const findSysTags = (data) => request.postZg('/zg_article/sysTags/findSysTags',data,{'X-No-Token': true})

